<template>
  <div class="px-5 py-5 p-lg-0 h-screen bg-surface-secondary d-flex flex-column justify-content-center">
    <Header></Header>
    <vue-element-loading :active="loading" :is-full-screen="true" spinner="ring" />

    <div class="d-flex justify-content-center">
      <div class="col-12 col-md-9 col-lg-6 min-h-lg-screen d-flex flex-column justify-content-center py-lg-16 px-lg-20 position-relative">
        <div class="row">
          <div class="col-lg-10 col-md-9 col-xl-7 mx-auto">
            <div class="text-center mb-12">
              <h1 class="ls-tight font-bolder mt-6">Welcome back!</h1>
              <p class="mt-2">Let's build something great</p>
            </div>

            <div class="mb-5">
              <label class="form-label" for="email">Email address / Username</label>
              <input
                id="email"
                type="text"
                class="form-control"
                ref="email"
                v-model="identity"
                placeholder="Enter email or username"
                @keyup.enter="clickEnterKey('email')"
              />
            </div>

            <div class="mb-5">
              <div class="d-flex align-items-center justify-content-between">
                <div><label class="form-label" for="password">Password</label></div>
              </div>
              <input
                id="password"
                type="password"
                class="form-control"
                ref="password"
                v-model="password"
                placeholder="Password"
                autocomplete="current-password"
                @keyup.enter="clickEnterKey('password')"
              />
            </div>

            <div>
              <button class="btn btn-primary w-full" :disabled="loading" @click="handleLogin">
                <span v-if="loading">Signing in...</span>
                <span v-else>Sign in</span>
              </button>
            </div>

            <div class="my-6 text-center">
              <small>Don't have an account?</small>
              <router-link to="/register" class="ms-2 text-warning text-sm font-semibold">Sign up</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/commons/HeaderItem.vue";
import { Account } from "@/api";
import { isEmpty } from "@/utils/validate";

export default {
  name: "LoginItem",
  components: { Header },
  data() {
    return {
      identity: "",
      password: "",
      loading: false,
    };
  },
  methods: {
    clickEnterKey(ref) {
      if (ref === "password") {
        if (!isEmpty(this.password)) this.handleLogin();
      } else {
        if (!isEmpty(this.identity)) this.$refs.password.focus();
      }
    },

    async handleLogin() {
      console.log("Login sequence started...");
      
      if (isEmpty(this.identity) || isEmpty(this.password)) {
        this.$message.warning("Please fill in all fields");
        return;
      }

      this.loading = true;
      try {
        console.log("Attempting PB authentication for:", this.identity);
        
        // 1. 执行登录
        const authData = await Account.login({
          identity: this.identity.trim(),
          password: this.password,
        });
        
        console.log("Auth successful, received token:", !!authData.token);

        // 2. 检查 AuthStore 是否真的更新了
        if (!Account.isAuthenticated()) {
          throw new Error("SDK failed to persist authentication state.");
        }

        this.$message.success("Login successful!");

        // 3. 执行跳转
        // 重点：我们直接跳转到子路由的全路径，避免 alias 重定向带来的不确定性
        const redirect = this.$route.query.redirect || "/functionItem/analysis";
        console.log("Redirecting to:", redirect);
        
        this.$router.replace(redirect).catch(err => {
          console.error("Router navigation error:", err);
        });

      } catch (err) {
        console.error("Login detailed error:", err);
        
        const errorMsg = err?.data?.message || err?.message || "Invalid credentials.";
        
        // 使用标准的 alert 如果 $MessageBox 没定义
        if (this.$MessageBox) {
          this.$MessageBox.alert(errorMsg, "Error", { type: "error" });
        } else {
          alert("Error: " + errorMsg);
        }
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    // 自动登录检查
    if (Account.isAuthenticated()) {
      console.log("Valid session found, auto-redirecting...");
      try {
        await Account.refresh();
        this.$router.replace(this.$route.query.redirect || "/functionItem/analysis");
      } catch (e) {
        console.warn("Auto-refresh failed, stay on login page");
      }
    }
  },
};
</script>